import React from 'react';

interface PageContentProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
}

/**
 * PageContent - Clean Content Wrapper
 * 
 * Provides consistent page layout without any navigation concerns.
 * Navigation is handled by the AppLayout wrapper automatically.
 * 
 * This component focuses ONLY on:
 * - Content layout and spacing
 * - Page header with title/description/actions
 * - Consistent typography and styling
 * 
 * Benefits:
 * - Clean separation from navigation logic
 * - Consistent page structure across all pages
 * - Easy to maintain and modify
 * - No knowledge of AppShell or navigation
 */
export function PageContent({ 
  children, 
  title, 
  description, 
  actions, 
  className = '' 
}: PageContentProps) {
  return (
    <div className={`p-6 space-y-6 ${className}`}>
      {/* Page Header */}
      {(title || description || actions) && (
        <div className="flex items-center justify-between">
          <div>
            {title && (
              <h1 className="text-2xl font-bold">{title}</h1>
            )}
            {description && (
              <p className="text-base-content/70 mt-1">{description}</p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2">
              {actions}
            </div>
          )}
        </div>
      )}
      
      {/* Page Content */}
      <div>
        {children}
      </div>
    </div>
  );
} 